import axios from 'axios';
import { NEWS_API_URL } from 'lib/api';
import { getHeaders } from './headers';

export const setLikes = async (id) => {
  try {
    const res = await axios.post(`${NEWS_API_URL}/post/setLike/${id}`, null, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const removeLike = async (id) => {
  try {
    const res = await axios.delete(`${NEWS_API_URL}/post/removeLike/${id}`, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const getMyLikes = async () => {
  try {
    const res = await axios.get(`${NEWS_API_URL}/post/getMyLikes`, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};

export const getPostsLikes = async (id) => {
  try {
    const res = await axios.get(`${NEWS_API_URL}/post/getLikes/${id}`, getHeaders());
    if (res.data.name === 'AxiosError') return null;

    return res.data;
  } catch (e) {
    return e;
  }
};
